import React, { ReactElement } from "react";
import { GetServerSideProps } from "next";
import { getPageProps } from "@services/initial-calls";
import BestTeethAlignersWrapper from "@components/layouts/bestteethalignersWrapper";
import ContactTop from "@components/antiviruschoice/contactTop";
import FormSection from "@components/antiviruschoice/formSection";

export default function NextAutoWarrantyHome(): ReactElement {
    return (
        <BestTeethAlignersWrapper>
            <div className="bg-white">
                <ContactTop iconsFillColor="#3D71E8" />
            </div>
            <FormSection iconsFillColor="#3D71E8" />
        </BestTeethAlignersWrapper>
    );
}

export const getServerSideProps: GetServerSideProps = async (context) => {
    return await getPageProps(context, "home", { pageTitle: "Contact Us" });
};
